import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import useWeb3Ctx from '../../../hooks/useWeb3Ctx';
import useAppCtx from '../../../hooks/useAppCtx';
import { useEnsNftContract } from '../../../hooks/useContract';
import useEnsTokens from '../../../hooks/useEnsTokens';
import config from '../../../config';

import Card from '../../common/Card';
import FullscreenModal from '../../common/FullscreenModal';
import Title from '../../common/Title';
import card from '../../../assets/images/card.svg';
import card2 from '../../../assets/images/card2.jpg';
import card3 from '../../../assets/images/card3.jpg';
import card4 from '../../../assets/images/card4.jpg';
import card5 from '../../../assets/images/card5.jpg';
import card6 from '../../../assets/images/card6.jpg';
import card7 from '../../../assets/images/card7.jpg';
import card8 from '../../../assets/images/card8.jpg';
import card9 from '../../../assets/images/card9.jpg';
import card10 from '../../../assets/images/card10.jpg';
import card11 from '../../../assets/images/card11.jpg';
import card12 from '../../../assets/images/card12.jpg';

import placeholder from '../../../assets/images/placeholder.jpeg';

import { toast } from 'react-toast';
import { Box, Typography, Button } from '@mui/material';

const sx = {
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    pb: '60px',
    textAlign: 'center',
    mt: 0,
    mx: 'auto',
  },

  btn: {
    mx: 'auto',
    my: 4,
    fontSize: '20px',
    width: '180px',
    fontFamily: 'boucherie-block',
    borderRadius: '0px',
    minHeight: '65px',
    border: '2px solid #020100',
    backgroundColor: '#020100',
    backgroundClip: 'content-box',
    padding: '5px',
    '&:hover': {
      border: '2px solid #9D4C10',
      backgroundColor: '#9D4C10',
    },
    '&:active': {
      border: '2px solid #6A330A',
      backgroundColor: '#6A330A',
    },
  },

  darkOverlay: {
    position: 'fixed',
    zIndex: 1000,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.8)',
  },
};

const Redemption = () => {
  const {
    address,
    handleConnect,
    handleDisconnect,
    walletCheck,
    correctNetwork,
  } = useWeb3Ctx();
  const { setTxInProgress, setTxEtherScan } = useAppCtx();
  const history = useHistory();

  const [open, setOpen] = useState(false);
  const [fullscreenSrc, setFullscreenSrc] = useState(null);

  const [eligible, setEligible] = useState(false);
  const [whitelistJson, setWhitelistJson] = useState(null);
  const [whitelistSignature, setWhitelistSignature] = useState(false);
  const [approvePending, setApprovePending] = useState(false);

  const [seriesName, setSeriesName] = useState('');
  const [seriesId, setSeriesId] = useState(null);
  const [startTime, setStartTime] = useState(0);
  const [endTime, setEndTime] = useState(0);
  const [cardLeft, setCardLeft] = useState(0);
  const [cardTotal, setCardTotal] = useState(144);
  const [mintEnded, setMintEnded] = useState(false);

  const { getTokens } = useEnsTokens();

  const ensContract = useEnsNftContract();

  const fetchJSONDataFrom = useCallback(async (path) => {
    await fetch(path, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then(async (res) => {
        const data = await res.json();
        setWhitelistJson(data);
      })
      .catch((e) => {
        console.error(e);
        setWhitelistJson(null);
      });
  }, []);

  useEffect(() => {
    if (seriesId) {
      fetchJSONDataFrom(config.BASE_URL + 'whitelist');
    }
  }, [fetchJSONDataFrom, seriesId]);

  useEffect(() => {
    if (ensContract) {
      (async () => {
        let name,
          seriesId,
          seriesStart,
          seriesEnd,
          minted,
          initialCards,
          cardLeft,
          startTime,
          endTime;

        const allData = await ensContract.getAllData();
        let currentSeriesIndex =
          Number(allData[6]) - 1 < 0 ? 0 : Number(allData[6]) - 1;

        console.log(allData);
        console.log(currentSeriesIndex);

        if (allData[0] instanceof Array) {
          name = allData[0][currentSeriesIndex];
          seriesId = currentSeriesIndex + 1;
          seriesStart = Number(allData[1][currentSeriesIndex]);
          seriesEnd = Number(allData[2][currentSeriesIndex]);
          minted = Number(allData[3][currentSeriesIndex]);
          initialCards = Number(allData[4][currentSeriesIndex]);
          cardLeft = Number(allData[5][currentSeriesIndex]);
          endTime = Number(allData[7][currentSeriesIndex]);
        } else {
          name = allData[0];
          seriesId = 1;
          seriesStart = Number(allData[1]);
          seriesEnd = Number(allData[2]);
          minted = Number(allData[3]);
          initialCards = Number(allData[4]);
          cardLeft = Number(allData[5]);
        }

        // console.log("startTime ", new Date(startTime * 1000).toLocaleString());
        console.log('endTime local', new Date(endTime * 1000).toLocaleString());
        console.log('seriesId', seriesId);
        // console.log("end", endTime);
        // console.log("now", now);
        if (endTime != null) {
          let now = Date.parse(new Date()) / 1000;
          setMintEnded(Math.floor(Number(endTime)) - now < 0);
          console.log('mintEnded', Math.floor(Number(endTime)) - now < 0);
        }
        setCardLeft(cardLeft);
        setCardTotal(initialCards);
        setSeriesId(seriesId);
        setSeriesName(name);
      })();
    }
  }, [ensContract]);

  useEffect(() => {
    if (address && whitelistJson) {
      const key = Object.keys(whitelistJson).find(
        (key) => key.toLowerCase() == address.toLowerCase()
      );
      if (key) {
        console.log('Found whitelist', key);
        setWhitelistSignature(whitelistJson[key][0]);
      } else {
        setWhitelistSignature(null);
      }
    } else setWhitelistSignature(null);
  }, [address, whitelistJson]);

  useEffect(() => {
    if (whitelistSignature) {
      setEligible(true);
    } else {
      setEligible(false);
    }
  }, [whitelistSignature]);

  const setFullscreenSource = (src) => {
    setFullscreenSrc(src);
    setOpen(true);
  };

  const checkWallet = async () => {
    const walletReady = await walletCheck();
    if (!walletReady && !correctNetwork) {
      return;
    } else {
      await mint();
    }
  };

  const mint = async () => {
    if (approvePending) return;
    setApprovePending(true);
    console.log('start mint');
    console.log(whitelistSignature);

    let gasLimit = await ensContract.estimateGas
      .whitelistMint(seriesId, whitelistSignature)
      .catch(handleError);

    if (gasLimit) {
      await ensContract
        .whitelistMint(seriesId, whitelistSignature)
        .then((tx) => {
          setApprovePending(false);
          setTxInProgress(true);
          console.log(`${config.ETHERSCAN_URL}tx/${tx.hash}`);
          setTxEtherScan(`${config.ETHERSCAN_URL}tx/${tx.hash}`);
          return tx.wait().then((receipt) => {
            if (receipt && receipt.status === 1) {
              setTxInProgress(false);
              setTxEtherScan(null);
              toast.success('Successfully Minted NFT');
              getTokens();

              history.replace({ ...history.location, state: null });
              history.push({
                pathname: '/wallet',
              });
            } else {
              toast.error('Transaction Failed');
              setTxInProgress(false);
              setTxEtherScan(null);
            }
          });
        })
        .catch(handleError);
    }
    setTxInProgress(false);
    setApprovePending(false);
  };

  const handleError = (e) => {
    console.error(e);
    if (e.error && e.error.message) {
      toast.error(e.error.message);
    } else if (e.message) {
      toast.error(e.message);
    } else if (e.reason) {
      toast.error(e.reason);
    }
  };

  const getCardImageBySeriesId = (seriesId) => {
    if (seriesId == 1) {
      return card;
    } else if (seriesId == 2) {
      return card2;
    } else if (seriesId == 3) {
      return card3;
    } else if (seriesId == 4) {
      return card4;
    } else if (seriesId == 5) {
      return card5;
    } else if (seriesId == 6) {
      return card6;
    } else if (seriesId == 7) {
      return card7;
    } else if (seriesId == 8) {
      return card8;
    } else if (seriesId == 9) {
      return card9;
    } else if (seriesId == 10) {
      return card10;
    } else if (seriesId == 11) {
      return card11;
    } else if (seriesId == 12) {
      return card12;
    } else return placeholder;
  };

  return (
    <Box sx={sx.root}>
      <Typography
        variant="body1"
        sx={{
          margin: 'auto',
          mb: '59px',
          marginTop: '59px',
          maxWidth: '728px',
        }}
      >
        Collect all 12 unique ENS Equinox NFTs for the opportunity to forge the
        ultimate 13th edition NFT! The final special edition NFT will include a
        surprise to be announced in the future. The Forge opens on 23 October
        2023 and will remain open until further notice.
      </Typography>
      <Button
        variant="outlined"
        sx={sx.btn}
        onClick={() => history.push('/forge')}
        disabled={false}
      >
        Forge
      </Button>

      <FullscreenModal setOpen={setOpen} isOpen={open} imgSrc={fullscreenSrc} />
    </Box>
  );
};

export default Redemption;
